// Boundaries follow the hours offices actually assign: 2, 4 and 8 are the most common, then whole 8-hour days.
// The colors are the Okabe-Ito colorblind-safe palette.
export const HOUR_BUCKETS = [
    {key: 'upTo2', label: 'Up to 2 hrs', maxHours: 2, color: '#0072B2'},
    {key: 'upTo4', label: '3 - 4 hrs', maxHours: 4, color: '#009E73'},
    {key: 'upTo8', label: '5 - 8 hrs', maxHours: 8, color: '#E69F00'},
    {key: 'upTo16', label: '9 - 16 hrs', maxHours: 16, color: '#D55E00'},
    {key: 'over16', label: 'Over 16 hrs', maxHours: Infinity, color: '#CC79A7'},
];

export function bucketForHours(workHours) {
    return HOUR_BUCKETS.find(bucket => workHours <= bucket.maxHours);
}
